(ns rothko.tooltip.component)

(defn tip
  [{:keys [appearance ::label]}]
  (when label
    [:div.tooltip__tip.top-tip
     {:class appearance}
     label]))

(defn wrapper
  [{:keys [appearance ::tip]} & content]
  (into [:div.tooltip {:class appearance} tip] content))

(defn tooltip
  [{:keys [::label :appearance] :as props} & content]
  (let [props (merge {::tip [tip props]} props)]
    (into [wrapper props] content)))

(defn inline-tooltip [content tooltip]
  [:div.tooltip {:style {:display :inline-block}}
   content
   [:span.tooltip__tip.top-tip.small-grey.sw-triangle tooltip]])
